<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  updated () {
    // 禁止浏览器后退按钮
    window.history.pushState(null, null, window.Location.href)
  }
  // watch: {
  //   '$route.path':  (val)=> {

  //   }
  // }
}
</script>>

<style >
  *{padding: 0;margin: 0;box-sizing: border-box;}
  #app,body,html{height:100%;}

  @media ( max-width: 400px) {
    /* 针对所有 Element 弹出框的公共样式 768px*/
    /*.el-dialog {
       确保弹出框在小屏幕下宽度适配，避免过宽
      max-width: 90vw !important;
      width: auto !important;
    }*/

    /* 针对消息提示框（MessageBox）的样式  width: auto !important;*/
    .el-message-box {
      max-width: 90vw !important;
      width: 350 !important;
    }
  }
  /* 若需要更精细的居中，可调整定位 */
  .el-dialog__wrapper,
  .el-message-box__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
